export default {
  appName     : 'MiniPOS',
  globalError : 'An error occurred. Please contact technical support!',
  navbar      : {
    contact  : 'Contact Us',
    language : {
      tw : '繁體中文',
      cn : '简体中文',
      en : 'English'
    }
  },
  features : {
    customization                 : 'Customizable options available',
    customization_desc_1          : 'Need biometric login, MDM integration, or a custom theme? ',
    customization_desc_2          : 'We support tailored solutions to help you create a communication tool that’s truly yours.',
    customization_desc_3          : '',
    privacy_security              : 'Privacy and Security',
    privacy_security_desc_1       : 'All messages are protected with end-to-end encryption to ensure the privacy of your conversations and the security of your data.',
    privacy_security_desc_2       : 'Data can be fully managed and controlled by the customer.',
    streamlining_processes        : 'Cross-Platform Communication',
    streamlining_processes_desc_1 : 'Not just viewing messages,',
    streamlining_processes_desc_2 : 'Whisp lets you send and receive messages with friends on other platforms.'
  },
  contact : {
    subject       : 'Contact Us Email from Whsip',
    submitSuccess : 'sent successfully !',
    continue      : 'continue to fill in new message?'
  },
  redirect : {
    errorMessageTitle : 'An Error Occurred!'
  },
  formTemplate : {
    upload       : 'Upload File',
    reset        : 'Reset',
    submit       : 'Submit',
    input        : 'Input',
    choose       : 'Choose',
    beforeRemove : 'Confirm Removal',
    handleExceed : 'Upload up to one file. Please delete the previous item first',
    error        : 'Failed',
    cancel       : 'Cancel'
  },
  form : {
    required            : '「{field}」 is required.',
    emailRequireMessage : 'Please enter an email',
    emailFormatMessage  : 'Invalid email format',
    emailPlaceholder    : 'Please enter your email',
    imageSizeLimitMb    : 'Image must not exceed {limit} MB.',
    buttonConfirm       : 'Confirm',
    search              : 'Search',
    clear               : 'Clear',
    back                : 'Back'
  },
  policy : {
    copyright : 'Copyright policy',
    privacy   : 'Privacy policy'
  },
  errorPage : {
    403 : {
      p1 : 'You do not have permission to access this page',
      p2 : 'Return to homepage',
      p3 : 'Return to previous page'
    },
    404 : {
      p1 : 'The page you are looking for does not exist!',
      p2 : 'Return to homepage',
      p3 : 'Return to previous page'
    }
  }
}
